module.exports = __webpack_public_path__ + "static/media/kernel-discussion-img.a6e48696.png";